var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownloadAttachment = function SvgDownloadAttachment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    fillRule: "nonzero",
    d: "M8.467.06C3.83.06.06 3.83.06 8.467c0 4.637 3.77 8.407 8.407 8.407 4.637 0 8.407-3.77 8.407-8.407 0-4.637-3.77-8.407-8.407-8.407zm0 15.645A7.244 7.244 0 0 1 1.23 8.467 7.244 7.244 0 0 1 8.467 1.23a7.244 7.244 0 0 1 7.238 7.237 7.244 7.244 0 0 1-7.238 7.238zM6.15 11.249h4.657a.585.585 0 0 1 0 1.17H6.149a.585.585 0 1 1 0-1.17zm2.318-.645L6.421 8.558a.584.584 0 1 1 .827-.827l.635.635v-3.91a.585.585 0 0 1 1.169 0v3.91l.635-.635a.584.584 0 1 1 .826.827l-2.046 2.046z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-attachment.0f34bfae16d462e5ae2fb532e6cd81a8.svg";